import {
  changeStatus,
  getStatus,
  list,
  protectAll,
  unprotectAll,
  refresh,
  backupAll,
  backupAllActiveSeats,
  exportSnapshot,
} from "@/services/api/app/seat-management/team";
import {defaultPagination} from "@/services/pagination";
import {
  listIncludeInBackups,
  updateIncludeInBackup,
  updateLocalIncludeInBackup
} from "@/services/api/app/seat-management/includeInBackup";
import {formatIncludeInBackup} from "@/services/formatters/includeInBackup";

const defaultState = () => ({
  teams: [],
  teamsMap: {},
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  filter: {
    statuses: null,
  },
  status: null,
  includeInBackups: [],
});

export default {
  namespaced: true,

  actions: {
    list({commit, state},) {
      return list({
        pagination: state.pagination,
        filter: state.filter,
        search: state.search
      })
        .then(({result, pagination, search, statuses}) => {
          commit('setTeams', result)
          commit('setPagination', pagination)
        })
    },
    listIncludeInBackup({commit}) {
      return listIncludeInBackups({
        providerType: 1,
        seatType: 'Team'
      })
        .then((result) => {
          commit('setIncludeInBackups', result)
        })
    },
    updateIncludeInBackup(context, payload) {
      const body = {
        seatType: 'Team',
        providerType: 1,
        applyToAll: payload.applyToAll,
        config: payload.config
      }
      return updateIncludeInBackup(body)
    },
    updateLocalIncludeInBackup(context, payload) {
      const body = {
        seatType: 'Team',
        providerType: 1,
        id: payload.id,
        applyToAll: payload.applyToAll,
        config: payload.config
      }
      return updateLocalIncludeInBackup(body)
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    refresh({commit}) {
      return refresh()
    },
    backupAll({commit}) {
      return backupAll()
    },
    backupAllActiveSeats() {
      return backupAllActiveSeats()
    },
    protectAll() {
      return protectAll();
    },
    unprotectAll() {
      return unprotectAll();
    },
    exportSnapshot({commit, state}, {filter, search, pagination}) {
      return exportSnapshot(filter, search, pagination);
    },
  },

  mutations: {
    setTeams(state, teams) {
      state.teams = teams;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatus(state, status) {
      state.status = status
    },
    setIncludeInBackups(state, data) {
      state.includeInBackups = data;
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  getters: {
    includeInBackupsFormatted: (state) => {
      return formatIncludeInBackup(state.includeInBackups);
    }
  },

  state: defaultState()
}
